import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 交接单 列表
 */
export function getPageList(data) {
  return fetch({
    url: '/sale/transferOrder/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除记录
 */
export function deleteData(data) {
  return fetch({
    url: '/sale/transferOrder/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存记录
 */
export function saveData(data) {
  return fetch({
    url: '/sale/transferOrder/save',
    method: 'POST',
    data
  })
}

//接收项目
export function accept(data) {
  return fetch({
    url: '/sale/transferOrder/accept',
    method: 'POST',
    data
  })
}

/**
 * 用户下啦接口
 * @param {*}
 */
export function getUserSimpleList(data) {
  return fetch({
    url: '/auth/subPlatform/user/simpleList',
    method: 'POST',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/salesManagement/transferOrder.js